<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse1"
                    aria-expanded="false" aria-controls="collapse1">
                Belastingplichtige
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse show" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Vermeld hier de naam van de belastingplichtige waarvoor je aangifte doet.</p>
                <p>Bij een fiscale eenheid vermeld je de naam van de moedermaatschappij.</p>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                RSIN/fiscaal nummer
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Je vindt het RSIN/fiscaal nummer in de aangiftebrief die de vennootschap van de Belastingdienbst
                    heeft ontvangen.</p>

                <p>Als het een RSIN/fiscaal nummer is van minder dan 9 cijfers, vul dan aan het begin nullen in, tot
                    een 9-cijferig nummer ontstaat. Bijvoorbeeld: 1234567 wordt 001234567.</p>

                <p>Als je aangifte doet voor een fiscale eenheid, vermeld dan het RSIN/fiscaal nummer van de
                    moedermaatschappij.</p>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading3">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
                Boekjaar
            </button>
        </h2>
        <div id="collapse3" class="accordion-collapse collapse" aria-labelledby="heading3"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Je vindt het boekjaar op de aangiftebrief die aan de vennootschap is uitgereikt.</p>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading4">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse4" aria-expanded="false" aria-controls="collapse4">
                Aangifte voor fiscale eenheid
            </button>
        </h2>
        <div id="collapse4" class="accordion-collapse collapse" aria-labelledby="heading4"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Kies 'Ja' als er voor dit boekjaar een beschikking fiscale eenheid is voor de
                    vennootschapsbelasting. Kies ook 'Ja' als de fiscale eenheid in de loop van dit boekjaar is
                    beëindigd.</p>
                <p>Beantwoord bij een aangifte de 'vragen vooraf' op het niveau van de fiscale eenheid en bij een
                    verzoek of wijziging voorlopige aanslag de samenstelling van de fiscale eenheid.</p>
            </div>
        </div>
    </div>
</div>
